import $ from 'jquery';
import PhotoSwipe from 'photoswipe/dist/photoswipe.js';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js';
const options = {
    index: 0,
    history: true,
    zoomEl: true,
    galleryUID: 1911,
    fullscreenEl: true,
    shareEl: false,
    tapToClose: true,
    closeOnScroll: false,
    tapToToggleControls: false
};
/**
 * @description Init PhotoSwipe gallery for product images
 */ export const init = async function() {
    const pswpElement = $('#js-pswp').get(0);
    $('.js-lightbox-trigger').on('click', function(evt) {
        evt.preventDefault();
        const imageSizes = $(evt.delegateTarget).attr('href') || '';
        if (!imageSizes) {
            return;
        }
        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, [
            {
                html: [
                    '<div class="Product-lightboxImage lazyload"',
                    `  data-bgset='${imageSizes}' data-sizes='auto'>`,
                    '</div>'
                ].join('')
            }
        ], options);
        gallery.init();
    });
};
